import scrollTo from 'utils/scrollTo';

class HandleModal {
  _state = {
    modalOpen: false,
    scroll: 0,
  };

  static options = {
    pace: 350,
    offset: 0,
    cookieName: 'preference_market',
  };

  constructor(element, options) {
    this._element = element;
    this._options = { ...HandleModal.options, ...options };
    this._cacheSelectors();
    this._initialize();
  }

  _cacheSelectors() {
    this._elements = {
      html: document.documentElement,
      body: document.body,
      toggleButtons: [...document.querySelectorAll(this._options.toggle)],
      closeButtons: [...this._element.parentNode.querySelectorAll(this._options.close)],
      anchor: this._element.querySelector(this._options.regionanchor),
      header: this._element.querySelector(this._options.header),
      menu: this._element.parentNode.querySelector(this._options.menu),
    };
  }

  _initialize() {
    this._elements.closeButtons.forEach((el) => {
      el.addEventListener('click', () => {
        this._state.modalOpen = false;
        this._handleModal();
      });
    });
    this._elements.toggleButtons.forEach((el) => {
      el.addEventListener('click', () => {
        this._state.modalOpen = !this._state.modalOpen;
        this._handleModal();
      });
    });
    if (this._elements.anchor !== null) {
      this._elements.anchor.addEventListener('click', (e) => {
        e.preventDefault();
        const hash = this._elements.anchor.href.split('#');
        scrollTo(
          this._element.querySelector(`[id="${hash[1]}"]`),
          this._options.offset,
          this._options.pace,
          this._element
        );
      });
    }
  }

  /**
   * Handle modal state
   * @param {*} event
   */
  _handleModal() {
    this._elements.html.setAttribute('data-overflow', !this._state.modalOpen);
    this._elements.body.setAttribute('data-modal', this._state.modalOpen);
    this._element.setAttribute('data-open', this._state.modalOpen);
    /* eslint-disable-next-line */
    this._state.modalOpen ? this._disableScroll() : this._enableScroll();
  }

  _enableScroll() {
    this._elements.body.scrollTop = this._elements.html.scrollTop = this._state.scrollTop;
    this._state.scrollTop = 0;
    this._element.scrollTop = 0;
  }

  _disableScroll() {
    this._state.scrollTop = this._elements.body.scrollTop || this._elements.html.scrollTop;
  }
}

export default HandleModal;
